import React from 'react';
import {Modal, ModalHeaderProps} from '@mantine/core';

export const EtroModalHeader: React.FC<ModalHeaderProps> = props => {
  return <Modal.Header {...props} />;
};
